
namespace TabAurous.HR {

    @Serenity.Decorators.registerClass()
    export class LeavePolicyGrid extends Serenity.EntityGrid<LeavePolicyRow, any> {
        protected getColumnsKey() { return 'HR.LeavePolicy'; }
        protected getDialogType() { return LeavePolicyDialog; }
        protected getIdProperty() { return LeavePolicyRow.idProperty; }
        protected getInsertPermission() { return LeavePolicyRow.insertPermission; }
        protected getLocalTextPrefix() { return LeavePolicyRow.localTextPrefix; }
        protected getService() { return LeavePolicyService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}